/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum VergelijkingUitstroomniveauVSO {
    ONDER_NIVEAU = "Onder niveau",
    OP_NIVEAU = "Op niveau",
    BOVEN_NIVEAU = "Boven niveau"
}
